const defaultRoutes = {
    'USER': '/dashboard/visitor',
    'OWNER': '/dashboard',
    'ICT': '/dashboard',
    'RECEPTION': '/dashboard/reception',
    'OFFICIAL': '/dashboard/official'
};

export { defaultRoutes };